enum CMMessageColourDefaults {
  RED = '#ff0000',
  BLUE = '#0052cc'
}

export { CMMessageColourDefaults };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/chat/_domain/models/cm-message-colour-defaults.ts